import DeviceCollection from 'app/stores/device/DeviceCollection';
import { api } from 'core/util';

class NonCloudDeviceCollection extends DeviceCollection {
  fetch(options = {}) {
    const { query = {} } = options;
    const { limit } = query;
    return super.fetch({ query: { filterCloud: true, limit } });
  }

  loadSparklineData() {
    return api
      .get('/api/ui/devices/sparklines')
      .then(
        ({
          cpu: cpuSparklines,
          memory: memorySparklines,
          temperature: temperatureSparklines,
          traffic: trafficSparklines
        }) => {
          this.get().forEach((device) => {
            const cpu = cpuSparklines[device.id];
            const memory = memorySparklines[device.id];
            const temperature = temperatureSparklines[device.id];
            const traffic = trafficSparklines[device.id];
            if (cpu) {
              device.set('cpu_util', cpu['last_total/instant']);
              device.set('cpu_util_timeseries', cpu.sparklineData);
            }

            if (memory) {
              device.set('memory_util', memory.last_memory_util);
              device.set('memory_util_timeseries', memory.sparklineData);
            }
            if (temperature) {
              device.set('temperature', {
                avg_instant: temperature.avg_instant,
                max_instant: temperature.max_instant,
                last_instant: temperature.last_instant
              });
              device.set('temperature_timeseries', temperature.sparklineData);
            }

            if (traffic) {
              device.set('traffic', traffic.f_sum_both_bytes__k_last);
              device.set('traffic_timeseries', traffic.sparklineData);
            }
          });
        }
      );
  }
}

export default NonCloudDeviceCollection;
